<style lang="less">
  // @import '../flow.less';
  @import '../idc/cmdb.less';
</style>

<template>
  <div class="container-monitor">
    <Card>
      <Row>
        <i-col>
          <Form :label-width="40" @submit.native.prevent>
            <FormItem label="容器">
                <Select style="max-width:332px;" @on-change="selectedVal">
                  <Option v-for="item in containerList" :value="item.url" :key="item.name">{{ item.url }}</Option>
                </Select>
            </FormItem>
          </Form>
        </i-col>
       </Row>
    </Card>
    <iframe :src="url" style="width:100%;min-height:700px;over-flow:hidden;border: 2px solid #ccc;"></iframe>
  </div>
</template>
<script>
import Tables from '_c/tables'
export default {
  name: 'container-monitor',
  components: {
    Tables
  },
  data () {
    return {
      containerList: [],
      url: ''
    }
  },
  methods: {
    getContainerList: function () {
      this.containerList = [
        {'name': 'container1', url: '10.1.2.169'},
        {'name': 'container2', url: '10.1.2.149'}
      ]
    },
    selectedVal (value) {
      this.url = 'http://' + value + ':18080/containers/'
    }
  },
  wathch: {
  },
  mounted: function () {
    this.getContainerList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
